import { Show, type JSX } from 'solid-js'

import Css from './ui.module.scss'

/** Um cartao branco com titulo e, opcionalmente, acoes no canto. */
export function Panel(props: {
    title?: string

    /**
     * O nivel de CIMA, quando o painel esta mostrando um nivel de dentro.
     *
     * Desenhado como caminho no lugar do titulo - `‹ Historico por dia › 14/09/2026` -,
     * e nao como acao no canto oposto. A saida fica onde o olho ja esta: quem entrou
     * clicou numa celula da primeira coluna, a esquerda, e no canto direito ela estava a
     * quase mil pixels dali, em texto sem seta e sem moldura. E o caminho diz as duas
     * coisas de uma vez, que um botao "voltar" nao diz: em que nivel se esta, e qual e o
     * de cima.
     *
     * E o mesmo vocabulario do voltar da TELA (seta mais o nome do destino), em escala
     * menor por estar dentro de um cartao.
     */
    parent?: { label: string; onClick: () => void }

    /**
     * Uma cor que identifica o assunto do painel, desenhada como ponto antes do
     * titulo. Opcional, e ausente na maioria: so quem tem um vocabulario de cor
     * proprio a usa - hoje, as tabelas de fase do sono.
     */
    accent?: string

    actions?: JSX.Element
    children: JSX.Element
    class?: string
    /** Tira o respiro interno - para quem desenha tabela, que sangra ate a borda. */
    flush?: boolean
}): JSX.Element {
    return (
        <section class={`${Css.panel} ${props.class ?? ''}`}>
            <Show when={props.title || props.actions}>
                <header class={Css.panelHeader}>
                    <Show when={props.title}>
                        {(title) => (
                            <h2 class={Css.panelTitle}>
                                <Show when={props.accent}>
                                    {(accent) => (
                                        // A borda existe para as cores claras: a fase LEVE e
                                        // quase branca, e um ponto sem contorno sumiria no
                                        // fundo do cartao.
                                        <span
                                            aria-hidden="true"
                                            class={Css.titleDot}
                                            style={{ 'background-color': accent() }}
                                        />
                                    )}
                                </Show>

                                {/*
                                    O botao mora DENTRO do `h2` de proposito: quem le por
                                    leitor de tela ouve o titulo inteiro - "Historico por
                                    dia, 14/09/2026" -, que e a informacao que o caminho
                                    carrega. A seta e o separador sao decoracao e saem da
                                    leitura.
                                */}
                                <Show when={props.parent}>
                                    {(parent) => (
                                        <>
                                            <button
                                                type="button"
                                                class={Css.panelParent}
                                                onClick={() => parent().onClick()}
                                            >
                                                <svg
                                                    aria-hidden="true"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path d="m15 18-6-6 6-6" />
                                                </svg>
                                                {parent().label}
                                            </button>
                                            <span aria-hidden="true" class={Css.panelSeparator}>
                                                ›
                                            </span>
                                        </>
                                    )}
                                </Show>

                                {title()}
                            </h2>
                        )}
                    </Show>
                    <Show when={props.actions}>{(actions) => <div class={Css.panelActions}>{actions()}</div>}</Show>
                </header>
            </Show>

            <div
                classList={{
                    [Css.panelBody]: !props.flush,
                    [Css.untitled]: !props.flush && !props.title
                }}
            >
                {props.children}
            </div>
        </section>
    )
}
